import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { key: 1 }
const _hoisted_2 = {
  key: 0,
  class: "header"
}

import VitaBeruLayout from '@/components/VitaBeruLayout.vue';
import VitaSideNav from '@/components/VitaSideNav.vue';
import VitaSubHeader from "@/components/VitaSubHeader.vue";
import router from "@/router";
import { NewUser, User } from "@/types";
import { isDevHost } from "@/utils/host";
import { isUserAuthenticated } from '@/utils/user';
import { useSavedMonth } from '@/composables/useSavedMonth';
import { computed } from "vue";
import { useStore } from "vuex";


export default /*@__PURE__*/_defineComponent({
  __name: 'BeruView',
  setup(__props) {

const store = useStore();
const users = computed<NewUser[]>(() => {
  return store.getters["data/pharmUsers"];
});

const userData = computed<User>(() => {
  return store.getters["user/userData"];
});


const sidebarCollapsed = computed(() => {
  return store.getters['getSidebarState']
})

const loader = computed<boolean>(() => {
  return store.getters["user/loader"];
});

const { getSavedMonth } = useSavedMonth()

const getPharmacies = async () => {
  !loader.value ? store.commit("user/setLoader", true) : null;
  store.commit("data/clearTomorrowWorkTime");
  store.commit("setDate", new Date());
  getSavedMonth()
  !userData.value ? await store.dispatch("user/userInfo") : null; // (OMR-7289)
  await store.dispatch("data/getPharmacies");
  await store.dispatch("data/getFondWorkTime");
  await store.dispatch("data/getHolidays");
  await store.dispatch("data/getFondWorkTimeHuman");
  store.commit("user/setLoader", false);
};

const token = localStorage.getItem("token");

const isBeruAccessRole = computed<boolean>(() => {
  return store.getters['getBeruAccessRole']
})

if (isUserAuthenticated()) {
  getPharmacies().then(() => {
    if (!isBeruAccessRole.value) {
      router.push("/");
    }
  });
} else {
  isDevHost() ? router.push({ name: "authentication-test" }) : router.push({ name: "authentication" })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["home", { 'collapsed': sidebarCollapsed.value }])
  }, [
    (!loader.value && (_unref(token) && users.value))
      ? (_openBlock(), _createBlock(VitaSideNav, { key: 0 }))
      : _createCommentVNode("", true),
    (!loader.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_unref(token) && users.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createVNode(VitaSubHeader)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            class: "content",
            style: _normalizeStyle('--users-count:' + users.value.length)
          }, [
            _createVNode(VitaBeruLayout)
          ], 4)
        ]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})